import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';
import FsCenterBox from 'ui-elements/common-elements/FsCenterBox';
import cn from 'classnames';

export const SwitchesWrapperBox = withStyles(({ spacing }) => ({
  root: {
    ...centerBoxProps,
    justifyContent: 'flex-start',
    overflowX: 'auto',
    paddingBottom: spacing(1),
  },
}))(Box);

interface SingleSwitchBoxProps extends BoxProps {
  isLast?: boolean;
}

export const SingleSwitchBox = withStyles(({ spacing }) => ({
  root: {
    marginRight: spacing(1.5),
    '&.isLast': {
      marginRight: 0,
    },
  },
}))(({ isLast, ...otherProps }: SingleSwitchBoxProps) => (
  <FsCenterBox {...otherProps} className={cn({ isLast })} />
));

export const Label = withStyles(({ spacing }) => ({
  root: {
    marginRight: spacing(0.5),
  },
}))(FsBody);
